<template>
    <el-dialog title="弃标" width="640px" center :visible.sync="visible.isShow">
        <el-form :model="unpaidForm"  label-width="100px" :rules="rules" ref="form">
            <el-form-item label="原因" prop="remark">
                <el-input type="textarea" v-model="unpaidForm.remark" :rows="4" placeholder="请输入弃标原因"></el-input>
            </el-form-item>
            <el-form-item label="附件" prop="files">
                <el-upload ref="upload"
                        class="upload-demo"
                        :action="uploadApi"
                        :on-success="filesSuccess"
                        :on-error="filesError"
                        :before-upload="beforeUpload">
                        <el-button size="mini" type="primary" :loading="loading">{{loading?'上传中...':'点击上传'}} </el-button>
                    <div slot="tip" class="el-upload__tip">上传附件大小请不要超过50M</div>
                </el-upload>
            </el-form-item>
        </el-form>
        <div class="btn-group">
            <el-button type="primary" @click="submit('form')">确定</el-button>
            <el-button @click="cancel('form')">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>    
import util from '@/util/'
export default {
    props:{
        visible:{
            type:Object,
            defualt:()=>{
                return { isShow:false}
            }
        },
        info:{
            type:Object,
            default:()=>{
                return {}
            }   
        }
    },
    data(){
        return {
            uploadApi: `${util.baseUrl}rest/file/upload`,
            unpaidForm:{
                remark:'',
                files:[],
            },
            rules:{
                remark:[
                    {required:true,message:'请输入弃标原因', trigger:'blur'},
                ],
                files:[
                    {required:true,type:'array',message:'请上传附件',trigger:'change'}
                ]
            },
            loading:false
        }
    },
    created(){
    },
    methods:{
        filesSuccess(response, file, fileList){
            this.unpaidForm.files = this.unpaidForm.files.concat(this._getBaseFiles(file,fileList));
            this.loading = false;
        },
        filesError(err, file, fileList){
            this.$message.error('上传出错，请稍后再试！');
        },
        beforeUpload(file){
            if(this.validFileSize(file.size)){
                this.$message.error('附件最大只能上传50M！');
                return false;
            }
            this.loading = true;

        },
        validFileSize(size){
            const MAX_SIZE = 50 * 1024 * 1024;
            return size > MAX_SIZE;
        },
        cancel(formName){
            this.$refs[formName].resetFields();
            this.visible.isShow = false;
            this.$refs['upload'].clearFiles();
        },
        submit(formName){
            this.$refs[formName].validate(valid =>{
                if(valid){
                    const subloading = this.$loading({background: 'rgba(255,255,255,0.5)'})
                    // 调用接口
                    this.$http.post('rest/api/invite/project/dropInvite', 
                        Object.assign({reason:this.unpaidForm.remark,files:this.unpaidForm.files},this.info)
                    ).then((res)=>{
                        subloading.close()
                        if (res.data.result) {
                            this.$message.success(res.data.message || '操作成功！');
                            this.cancel(formName);
                            this.$emit('update')
                        } else {
                            this.$message.error(res.data.message || '操作失败！');
                        }
                    })
                }else{
                    if(this.unpaidForm.files.length==0) {
                        this.$message({message:'请上传附件在提交',type:'error'});
                    }
                }
            })
        },

        _getBaseFiles(file,fileList){
            let fs = [];
            fileList.forEach(function (item) {
                console.log(item)
                if(item.response){
                    let f = item.response.basefiles[0];
                    item.bizTableName =  f.biztablename;
                    item.bizTablePkName =  f.biztablepkname;
                    item.bizTablePkValue =  f.biztablepkvalue;
                    item.fid =  f.fid;
                    item.fileCatagoryId = f.filecatagoryid;
                    item.fileDesc = f.filedesc;
                    item.fileOldName = f.fileoldname;
                    item.name = f.fileoldname;
                    item.fileName = f.filename;
                    item.filePath = f.filepath;
                    item.fileSize = f.filesize;
                    item.fileType = f.filetype;
                    item.sort = f.sort;
                }
                fs.push(item);
            });
            console.log(fs);
            return fs
        }

    }   

}
</script>

<style scope>
    .btn-group{
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/invite/UnpaidDialog.vue